<template>
  <span v-if="chainId">
    {{ network.name }}
  </span>
</template>

<script>

export default {
  name: 'announcement-network',
  props: {
    networks: {
      type: Array,
      default: () => [],
    },
    chainId: {
      type: Number,
      default: null,
    },
  },
  computed: {
    network () {
      const result = this.networks.find(n => +n.id === this.chainId)

      return result
    },
  },
}
</script>

<style scoped>

</style>
